import '../App.css'

export default function Navbar () {
  return (
    <>
      <div className="Navbar-custom">
        <div className="Title">
          <h1 className="Main-Title">Todos</h1>
        </div>
        <div className="Null-Navbar"></div>
        <div className="Null-Navbar"></div>
      </div>
    </>
  )
}